// extracted by mini-css-extract-plugin
export var page = "Page-module--page--2Y5e7";
export var page__inner = "Page-module--page__inner--2BLEK";
export var page__title = "Page-module--page__title--2NL7K";
export var page__body = "Page-module--page__body--1qXMF";